// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-indicator-container {
  position: relative;
  display: flex;
  align-items: center;
}

/* Main Status Badge */
.status-indicator {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: rgba(40, 40, 40, 0.9);
  border: 1px solid #3a3a3a;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.status-indicator:hover {
  background: rgba(50, 50, 50, 0.9);
  border-color: #4a4a4a;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.status-icon {
  font-size: 14px;
  font-weight: bold;
}

.status-text {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #ffffff;
}

/* Status-specific styles */
.status-indicator.status-ready {
  border-left: 3px solid #00a855;
}

.status-indicator.status-loading {
  border-left: 3px solid #ffa500;
}

.status-indicator.status-loading .status-icon {
  animation: spin 1s linear infinite;
}

.status-indicator.status-error {
  border-left: 3px solid #ff6b6b;
}

.status-indicator.status-partial {
  border-left: 3px solid #ffcc00;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Detailed Status Tooltip */
.status-details-tooltip {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 280px;
  background: rgba(30, 30, 30, 0.98);
  border: 1px solid #3a3a3a;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5);
  z-index: 1001;
  animation: tooltipFadeIn 0.2s ease-out;
}

@keyframes tooltipFadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.tooltip-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  background: rgba(40, 40, 40, 0.9);
  border-bottom: 1px solid #3a3a3a;
  border-radius: 8px 8px 0 0;
}

.tooltip-header h5 {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: #ffffff;
}

.close-tooltip-btn {
  background: transparent;
  border: none;
  color: #888888;
  font-size: 20px;
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.close-tooltip-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

.tooltip-content {
  padding: 14px;
}

/* Status Items */
.status-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 12px;
}

.status-item.overall {
  padding: 10px 0;
  font-weight: 600;
}

.item-label {
  color: #888888;
  font-weight: 500;
}

.item-status {
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 600;
}

.item-status.detail-success {
  color: #00a855;
}

.item-status.detail-loading {
  color: #ffa500;
}

.item-status.detail-error {
  color: #ff6b6b;
}

.item-status.detail-empty {
  color: #888888;
}

.item-status.detail-unknown {
  color: #666666;
}

.status-divider {
  height: 1px;
  background: #3a3a3a;
  margin: 8px 0;
}

/* Status Breakdown */
.status-breakdown {
  margin: 8px 0;
}

.breakdown-header {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #888888;
  margin-bottom: 8px;
}

.status-item.detail {
  padding: 6px 0;
  font-size: 11px;
}

.status-item.connection {
  padding: 8px 0;
}

/* Status Timestamp */
.status-timestamp {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #3a3a3a;
  text-align: center;
}

.status-timestamp small {
  font-size: 10px;
  color: #666666;
}

/* Status Legend */
.status-legend {
  padding: 10px 14px;
  background: rgba(25, 25, 25, 0.8);
  border-top: 1px solid #3a3a3a;
  border-radius: 0 0 8px 8px;
}

.legend-title {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #666666;
  display: block;
  margin-bottom: 8px;
}

.legend-items {
  display: flex;
  justify-content: space-around;
  gap: 8px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 4px;
}

.legend-icon {
  font-size: 12px;
  font-weight: bold;
}

.legend-icon.status-ready {
  color: #00a855;
}

.legend-icon.status-loading {
  color: #ffa500;
}

.legend-icon.status-error {
  color: #ff6b6b;
}

.legend-item small {
  font-size: 10px;
  color: #888888;
}

/* Responsive */
@media (max-width: 1366px) {
  .status-details-tooltip {
    width: 260px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/sidebar/StatusIndicator.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,kCAAkC;EAClC,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,iCAAiC;EACjC,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[".status-indicator-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n/* Main Status Badge */\n.status-indicator {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: rgba(40, 40, 40, 0.9);\n  border: 1px solid #3a3a3a;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.status-indicator:hover {\n  background: rgba(50, 50, 50, 0.9);\n  border-color: #4a4a4a;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.status-icon {\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.status-text {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #ffffff;\n}\n\n/* Status-specific styles */\n.status-indicator.status-ready {\n  border-left: 3px solid #00a855;\n}\n\n.status-indicator.status-loading {\n  border-left: 3px solid #ffa500;\n}\n\n.status-indicator.status-loading .status-icon {\n  animation: spin 1s linear infinite;\n}\n\n.status-indicator.status-error {\n  border-left: 3px solid #ff6b6b;\n}\n\n.status-indicator.status-partial {\n  border-left: 3px solid #ffcc00;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Detailed Status Tooltip */\n.status-details-tooltip {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  width: 280px;\n  background: rgba(30, 30, 30, 0.98);\n  border: 1px solid #3a3a3a;\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5);\n  z-index: 1001;\n  animation: tooltipFadeIn 0.2s ease-out;\n}\n\n@keyframes tooltipFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-5px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.tooltip-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 14px;\n  background: rgba(40, 40, 40, 0.9);\n  border-bottom: 1px solid #3a3a3a;\n  border-radius: 8px 8px 0 0;\n}\n\n.tooltip-header h5 {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.close-tooltip-btn {\n  background: transparent;\n  border: none;\n  color: #888888;\n  font-size: 20px;\n  cursor: pointer;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.close-tooltip-btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n}\n\n.tooltip-content {\n  padding: 14px;\n}\n\n/* Status Items */\n.status-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 0;\n  font-size: 12px;\n}\n\n.status-item.overall {\n  padding: 10px 0;\n  font-weight: 600;\n}\n\n.item-label {\n  color: #888888;\n  font-weight: 500;\n}\n\n.item-status {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-weight: 600;\n}\n\n.item-status.detail-success {\n  color: #00a855;\n}\n\n.item-status.detail-loading {\n  color: #ffa500;\n}\n\n.item-status.detail-error {\n  color: #ff6b6b;\n}\n\n.item-status.detail-empty {\n  color: #888888;\n}\n\n.item-status.detail-unknown {\n  color: #666666;\n}\n\n.status-divider {\n  height: 1px;\n  background: #3a3a3a;\n  margin: 8px 0;\n}\n\n/* Status Breakdown */\n.status-breakdown {\n  margin: 8px 0;\n}\n\n.breakdown-header {\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #888888;\n  margin-bottom: 8px;\n}\n\n.status-item.detail {\n  padding: 6px 0;\n  font-size: 11px;\n}\n\n.status-item.connection {\n  padding: 8px 0;\n}\n\n/* Status Timestamp */\n.status-timestamp {\n  margin-top: 10px;\n  padding-top: 10px;\n  border-top: 1px solid #3a3a3a;\n  text-align: center;\n}\n\n.status-timestamp small {\n  font-size: 10px;\n  color: #666666;\n}\n\n/* Status Legend */\n.status-legend {\n  padding: 10px 14px;\n  background: rgba(25, 25, 25, 0.8);\n  border-top: 1px solid #3a3a3a;\n  border-radius: 0 0 8px 8px;\n}\n\n.legend-title {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #666666;\n  display: block;\n  margin-bottom: 8px;\n}\n\n.legend-items {\n  display: flex;\n  justify-content: space-around;\n  gap: 8px;\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.legend-icon {\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.legend-icon.status-ready {\n  color: #00a855;\n}\n\n.legend-icon.status-loading {\n  color: #ffa500;\n}\n\n.legend-icon.status-error {\n  color: #ff6b6b;\n}\n\n.legend-item small {\n  font-size: 10px;\n  color: #888888;\n}\n\n/* Responsive */\n@media (max-width: 1366px) {\n  .status-details-tooltip {\n    width: 260px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
